import styled from 'styled-components';
import { Button } from '@bufferapp/ui';

export const ButtonWrapper = styled.span`
  display: flex;
`;

export const ButtonStyled = styled(Button)`
  margin-left: 8px;
`;

export const RequeueButton = styled(ButtonStyled)``;

export const SingleActionButton = styled(ButtonStyled)``;

export const StackedActionButton = styled(ButtonStyled)``;
